export default class Language {
	[x: string]: any;
	constructor(language, months, monthsAbbr, days) {
		this.language = language;
		this.months = months;
		this.monthsAbbr = monthsAbbr;
		this.days = days;
		this.rtl = false;
		this.ymd = false;
		this.yearSuffix = "";
		if (language === "French") {
			this.clearText = "Vider date";
			this.calendarIconText = "Ouvrir le calendrier";
			this.prevDecade = "DÃ©cennie prÃ©cÃ©dente";
			this.nextDecade = "DÃ©cennie suivante";
			this.prevYear = "AnnÃ©e prÃ©cÃ©dente";
			this.nextYear = "AnnÃ©e suivante";
			this.prevMonth = "Mois prÃ©cÃ©dent";
			this.nextMonth = "Mois suivant";
		} else {
			this.clearText = "Clear date";
			this.calendarIconText = "Open calendar";
			this.prevDecade = "Previous decade";
			this.nextDecade = "Next decade";
			this.prevYear = "Previous year";
			this.nextYear = "Next year";
			this.prevMonth = "Previous month";
			this.nextMonth = "Next month";
		}
	}

	get language() {
		return this._language;
	}

	set language(language) {
		if (typeof language !== "string") {
			throw new TypeError("Language must be a string");
		}
		this._language = language;
	}

	get clearText() {
		return this._clearText;
	}

	set clearText(text) {
		if (typeof text !== "string") {
			throw new TypeError("Clear text must be a string");
		}
		this._clearText = text;
	}

	get calendarIconText() {
		return this._calendarIconText;
	}

	set calendarIconText(text) {
		if (typeof text !== "string") {
			throw new TypeError("Calendar icon text must be a string");
		}
		this._calendarIconText = text;
	}

	get prevDecade() {
		return this._prevDecade;
	}

	set prevDecade(text) {
		if (typeof text !== "string") {
			throw new TypeError("Previous decade text must be a string");
		}
		this._prevDecade = text;
	}

	get nextDecade() {
		return this._nextDecade;
	}

	set nextDecade(text) {
		if (typeof text !== "string") {
			throw new TypeError("Next decade text must be a string");
		}
		this._nextDecade = text;
	}

	get prevYear() {
		return this._prevYear;
	}

	set prevYear(text) {
		if (typeof text !== "string") {
			throw new TypeError("Previous Year text must be a string");
		}
		this._prevYear = text;
	}

	get nextYear() {
		return this._nextYear;
	}

	set nextYear(text) {
		if (typeof text !== "string") {
			throw new TypeError("Next Year text must be a string");
		}
		this._nextYear = text;
	}

	get prevMonth() {
		return this._prevMonth;
	}

	set prevMonth(text) {
		if (typeof text !== "string") {
			throw new TypeError("Previous Month text must be a string");
		}
		this._prevMonth = text;
	}

	get nextMonth() {
		return this._nextMonth;
	}

	set nextMonth(text) {
		if (typeof text !== "string") {
			throw new TypeError("Next Month text must be a string");
		}
		this._nextMonth = text;
	}

	get months() {
		return this._months;
	}

	set months(months) {
		if (months.length !== 12) {
			throw new RangeError(`There must be 12 months for ${this.language} language`);
		}
		this._months = months;
	}

	get monthsAbbr() {
		return this._monthsAbbr;
	}

	set monthsAbbr(monthsAbbr) {
		if (monthsAbbr.length !== 12) {
			throw new RangeError(`There must be 12 abbreviated months for ${this.language} language`);
		}
		this._monthsAbbr = monthsAbbr;
	}

	get days() {
		return this._days;
	}

	set days(days) {
		if (days.length !== 7) {
			throw new RangeError(`There must be 7 days for ${this.language} language`);
		}
		this._days = days;
	}
}
// eslint-disable-next-line
